define.alias("shared/components/shared/plan-recommendation/plan-card", "media/components/shared/plan-recommendation/plan-card");